import { siteConfig } from '@/mocks/siteData';

export default function CTASection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20stylish%20modern%20fashion%20accessories%20and%20clothing%20items%20beautifully%20arranged%20on%20warm%20rust%20colored%20textured%20surface%2C%20abundant%20negative%20space%20on%20right%2C%20dramatic%20golden%20sunset%20lighting%20streaming%20from%20upper%20left%2C%20terracotta%20and%20sand%20color%20palette%2C%20artistic%20editorial%20product%20photography%2C%20warm%20atmospheric%20glow&width=1600&height=700&seq=cta-full-v2&orientation=landscape"
        alt="Mulebuy spreadsheet shopping collection"
        className="w-full h-full object-cover"
        title="Mulebuy Spreadsheet Shopping"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/45 via-black/25 to-transparent"></div>

      <div className="absolute inset-0 flex flex-col justify-between p-8 md:p-14">
        <div>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white lowercase">
            mulebuy spreadsheets
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6">
          <a
            href={siteConfig.mainSite}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-6 py-3.5 bg-white text-foreground-950 rounded-full font-semibold text-sm hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
          >
            <span>buy it now</span>
            <span className="w-7 h-7 bg-foreground-950 rounded-full flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-sm"></i>
            </span>
          </a>

          <p className="text-base md:text-lg text-white/80 max-w-xs text-right leading-relaxed">
            Compare products faster.
            <br />
            Reduce mistakes and track orders efficiently.
          </p>
        </div>
      </div>
    </section>
  );
}